import z from "zod";

/**
 * CopiarObraAreaChecklistSchema
 */

export const CopiarObraAreaChecklistSchema = z.object({
  area: z.string({ required_error: 'Este campo deve ser preenchido!' }).nonempty('Este campo deve ser preenchido!'),
  copiarChecklist: z.coerce.number({ required_error: 'Este campo deve ser preenchido!' }).default(0),
});

/**
 * CopiarObraAreaChecklistForm
 */

export type CopiarObraAreaChecklistForm = z.infer<typeof CopiarObraAreaChecklistSchema>;